<template>
  <a
    class="c-guided-quiz-answer"
    :class="{'c-guided-quiz-answer--small':allowMultiple}"
    role="checkbox"
    :aria-checked="active ? true : false"
    @click="selectAnswer"
  >
    <div
      class="c-guided-quiz-answer__image-wrapper"
      :class="{
        'c-guided-quiz-answer__image-wrapper--standard':!allowMultiple,
        'c-guided-quiz-answer__image-wrapper--small':allowMultiple,
        'c-guided-quiz-answer__image-wrapper--active':active}"
    >
      <img
        class="c-guided-quiz-answer__image"
        :src="displayImage.src"
        :alt="displayImage.alt || answer.title || 'Answer image'"
        role="presentation"
      >
    </div>
    <p
      class="t-heading-9"
      :class="{
        'c-guided-quiz-answer__label--standard': !allowMultiple,
        'c-guided-quiz-answer__label--small':allowMultiple
      }"
    >
      {{ answer.title }}
    </p>
  </a>
</template>

<script>
export default {
  name: "GuidedQuizAnswer",
  props: {
    answer: {
      type: Object,
      default: null
    },
    displayAlt: {
      type: Boolean,
      default: false
    },
    allowMultiple: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      active: false
    }
  },
  computed: {
    displayImage: function(){
      if(this.displayAlt && this.answer.altImage){
        return this.answer.altImage;
      }
      return this.answer.image;
    }
  },
  watch:{
    allowMultiple(newVal){
      if(!newVal){
        this.active = false;
      }
    }
  },
  mounted(){

  },
  methods: {
    selectAnswer(){
      if(this.allowMultiple){
        this.active = !this.active;
      }
      this.$emit("answer", this.answer);
    }
  }
}
</script>
<style lang="scss" scoped>
  .c-guided-quiz-answer{
    width: rem(190px);

    margin: rem(45px) rem(15px);
    cursor: pointer;
    text-align: center;

    &--small{
      width: rem(120px);

    }

    &__image-wrapper{
      border-radius: 50%;
      margin: 0 auto;
      overflow: hidden;
      &--wide{
        width: 89%;
      }
      &--standard{
        width: 89%;
      }
      &--small{
        width: 100%;
        display: flex;
        align-items: flex-start;
        padding: rem(7px) rem(7px) rem(7px);
      }
      &--active{
        @include themify($themes){
          border: $border themed("foreground")
        }
      }
    }

    &__image {
      width: 100%;
      border-radius: 50%;
    }

    &__label{
      &--standard{
        @include themify($themes){
          background-color: themed("foreground");
          color: themed("foreground", "white-text");
        }
        position: relative;
        display: inline-block;

        text-align: center;
        min-width: calc(100% - 20px);
        padding: 0 rem(6px);
        top: - rem(12px);
        margin-bottom: 0;
        white-space: nowrap;

        &::before, &::after{
          position: absolute;
          content: "";
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
        }

        &::before{
          left: -6px;
          @include themify($themes) {
            border-bottom: rem(18px) solid themed("foreground");
            @include respond("tab-land"){
              border-bottom-width: rem(20px);
            }
            @include respond("tab-port"){
              border-bottom-width: rem(23px);
            }
            @include respond("phone"){
              border-bottom-width: rem(23px);
            }
          }
        }

        &::after{
          right: -6px;
          @include themify($themes) {
            border-top: rem(18px) solid themed("foreground");
            @include respond("tab-land"){
              border-top-width: rem(20px);
            }
            @include respond("tab-port"){
              border-top-width: rem(23px);
            }
            @include respond("phone"){
              border-top-width: rem(23px);
            }
          }
        }
      }
      &--small{
        text-align: center;
      }
    }
  }
</style>
